import { render, staticRenderFns } from "./ReleaseNoteEditor.vue?vue&type=template&id=6911a36a&"
import script from "./ReleaseNoteEditor.vue?vue&type=script&lang=js&"
export * from "./ReleaseNoteEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports